/** routeIds can include an appended letter, such as 293a, representing future service changes
 This regex gets the numeric portion, which we need in order to query the data.
 *
 * @param {string|number} routeId ID string or number to be parsed
 * @returns {string}
*/
export const parseNumericalPortionOfRouteId = routeId => {
  return String(routeId).match(/\d+/)?.[0];
};

/**
 * Within the OTP itineraries many IDs are strings in the format:
 * `<agency-name>:<id-value>`, this function parses out the `id-value` which is
 * often needed to lookups on other transit data with in the app. Keys that hold
 * values in this format include `tripId`, `routeId` and `stopId`
 *
 * @param {string} idString ID string to be parsed
 * @param {boolean} [asNumber] Pass `true` to cast the return value to Number
 * @returns {number|string|null}
 */
export const parseOtpId = (idString, asNumber = false) => {
  if (!idString) {
    return null;
  }

  const parsedId = idString.split(':').pop();
  return asNumber ? Number(parseNumericalPortionOfRouteId(parsedId)) : parsedId;
};
